import { render } from "./AddIndividual.vue?vue&type=template&id=04aab468&scoped=true"
import script from "./AddIndividual.vue?vue&type=script&lang=js"
export * from "./AddIndividual.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&id=04aab468&scoped=true&lang=css"
import "./AddIndividual.vue?vue&type=style&index=1&id=04aab468&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04aab468"]])

export default __exports__